import { SxProps, Theme } from "@mui/material";

export const containerListStyles: SxProps = {
  display: "flex",
  flexDirection: "column",
  gap: 2,
  minWidth: 0,
};

export const messageBoxStyles: SxProps<Theme> = (theme) => ({
  background: theme.palette.panelInfo.message.bg,
  p: 2,
  borderRadius: 1,
  cursor: "pointer",
  transition: "background-color 0.2s ease-in-out",
  overflow: "hidden",
  minWidth: 0,
  "&:hover": {
    backgroundColor: theme.palette.panelInfo.message.bgHover,
  },
});

export const markdownBoxStyles: SxProps = {
  fontFamily: '"Red Hat Display", sans-serif',
  minWidth: 0,
  overflowWrap: "break-word",
  wordBreak: "break-word",
  overflow: "hidden",
  "& *": {
    overflowWrap: "break-word",
    wordBreak: "break-word",
  },
};

export const imageCollectionBoxStyles: SxProps = {
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  gap: 1,
  minWidth: 0,
};

export const textWrapperStyles: SxProps = {
  minWidth: 0,
  flex: 1,
  overflowWrap: "break-word",
  wordBreak: "break-word",
  overflow: "hidden",
  "& *": {
    overflowWrap: "break-word",
    wordBreak: "break-word",
  },
};

export const tabLabelsStyles = (theme: Theme): SxProps<Theme> => ({
  display: "flex",
  flexWrap: "wrap",
  gap: 0.5,
  mt: 1,
  "& > span": {
    fontSize: "11px",
    px: 1,
    py: 0.25,
    borderRadius: 1,
    backgroundColor: theme.palette.divider,
  },
});

export const messageFooterStyles: SxProps = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: "4px",
};

export const lessonBadgeStyles: SxProps<Theme> = (theme) => ({
  fontWeight: 500,
  fontSize: "12px",
  px: 1,
  py: 0.5,
  borderRadius: 1,
  backgroundColor: theme.palette.secondary.light,
  color: theme.palette.secondary.contrastText,
});
